module.exports = __webpack_public_path__ + "img/tooltip_04-vallone-aure-wood-noce-canaletto.55cb4313.jpg";